export const TESTIMONIALS = [
  {
    quote: "The Grill Master's Box turned every weekend into an event. Tomahawks, Wagyu burgers, honestly restaurant quality for less than we'd pay at a decent steakhouse.",
    name: "James M.",
    location: "Cottesloe, WA",
    plan: "Grill Master's Box · Monthly",
  },
  {
    quote: "We were spending $250+ a week at the local butcher and supermarket. The Family Feast box gives us better cuts for less and I don't have to think about what's for dinner.",
    name: "Sarah W.",
    location: "Applecross, WA",
    plan: "Family Feast Box · Fortnightly",
  },
  {
    quote: "The vacuum sealing is a game-changer for meal prep. Everything is labelled, portioned and freezes perfectly. The chicken stir-fry is a staple in our house now.",
    name: "Ethan L.",
    location: "Nedlands, WA",
    plan: "Performance Box · Fortnightly",
  },
  {
    quote: "Free Wagyu burgers every delivery + 5% off? It's a no-brainer. I paused twice while travelling and it was one click. Great to support Australian farms too.",
    name: "Olivia R.",
    location: "Subiaco, WA",
    plan: "Starter Box · Monthly",
  },
  {
    quote: "Best beef I've had outside a proper steakhouse. Scotch fillets are consistently well-marbled and the ribeye cooks like a dream. Highly recommend the Carnivore Box.",
    name: "Michael T.",
    location: "Fremantle, WA",
    plan: "Carnivore Collection · Monthly",
  },
  {
    quote: "I run a small cafe and the wholesale side is excellent — priced sharp and always on time. And I subscribe personally at home. Same quality, both sides.",
    name: "Chloe K.",
    location: "Mount Lawley, WA",
    plan: "Wholesale + Family Feast",
  },
];

export const STANDARDS = [
  {
    title: "100% Australian",
    seal: "AUS",
    body: "Every cut is sourced from family farms and trusted suppliers right here in Australia. Never imported, never anonymous.",
  },
  {
    title: "MSA Graded Beef",
    seal: "MSA",
    body: "Our premium beef is Meat Standards Australia graded — independently rated for tenderness, juiciness and flavour.",
  },
  {
    title: "Halal Certified",
    seal: "HALAL",
    body: "Every single cut is halal certified — beef, lamb and chicken, certified through accredited Australian halal authorities and traceable to accredited abattoirs. Not a halal range. The whole range.",
  },
  {
    title: "HACCP Certified",
    seal: "HACCP",
    body: "Every processing facility we work with is HACCP certified — the global gold standard for food safety.",
  },
  {
    title: "No Added Hormones",
    seal: "HGP-FREE",
    body: "No added hormones, ever. Antibiotics only used when medically necessary — never routinely, never as growth promoters.",
  },
  {
    title: "Pasture-Raised",
    seal: "PASTURE",
    body: "Lamb roams free on native pasture. Beef grazes on grass and forage. Chicken is free-range with continuous outdoor access.",
  },
];

export const FOUNDER_STORY = {
  headline: "From a family butcher shop to your front door.",
  para1: "THE BUTCHER BOX started with a simple idea: Australians deserve better meat than what most supermarkets serve up. No mystery cuts. No plastic-tray filler. No airline miles from South America.",
  para2: "Working directly with Australian family farms — many of them multi-generational — we curate boxes of restaurant-quality beef, lamb, chicken and gourmet meats, vacuum-pack every cut ourselves, and ship them cold to homes across Perth. Every subscription supports Australian farmers and delivers meat you can trace right back to the paddock.",
  image: "/img/wholesale-hero.png",
};

export const COMPARISON = {
  rows: [
    { label: "Premium Australian meat",           tbb: true, boutique: true,  supermarket: false },
    { label: "MSA graded beef",                    tbb: true, boutique: true,  supermarket: false },
    { label: "Vacuum sealed & labelled",           tbb: true, boutique: false, supermarket: false },
    { label: "Delivered cold to your door",        tbb: true, boutique: false, supermarket: false },
    { label: "Subscribe & save 5%",                tbb: true, boutique: false, supermarket: false },
    { label: "Halal certified — every cut",        tbb: true, boutique: false, supermarket: false },
    { label: "Free Wagyu burgers every delivery",  tbb: true, boutique: false, supermarket: false },
    { label: "Free delivery on every order",       tbb: true, boutique: false, supermarket: false },
    { label: "No added hormones, ever",            tbb: true, boutique: true,  supermarket: false },
    { label: "Pause / cancel anytime",             tbb: true, boutique: false, supermarket: false },
  ],
};
